import React from 'react';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  const imagekit = import.meta.env.VITE_IMAGEKIT_URL;
  return (
    <div
      className="relative min-h-screen text-white flex flex-col p-5 overflow-hidden bg-win-navy"
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Navy vignette overlay for contrast + brand tint */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-win-navy/85 via-win-navy/70 to-black/80" />

      {/* Logo */}
      <img src={`${imagekit}/logo.png`} alt="" className="w-32 relative z-10 drop-shadow-lg" />

      {/* Centered Section */}
      <div className="flex-grow flex items-center justify-center relative z-10">
        <div className="relative max-w-[440px] w-full mx-auto flex-center flex-col">
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <p className="relative z-10 text-center text-xs text-white/40 pb-1">
        &copy; {new Date().getFullYear()} All rights reserved.
      </p>
    </div>
  );
}
